import { render, staticRenderFns } from "./ViewerDeviceActions.vue?vue&type=template&id=a36accd6&scoped=true"
import script from "./ViewerDeviceActions.vue?vue&type=script&lang=ts"
export * from "./ViewerDeviceActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36accd6",
  null
  
)

export default component.exports